import React from 'react';
import { InputDateContainer, InputDateLabel, InputDateField, InputDateGroup, InputDateMessageError } from './styles';
import { FaRegCalendar } from 'react-icons/fa'
import colors from '../../assets/styles/colors';

const InputDate = ({ error, label, defaultValue, register, readOnly, onBlur, id, ...rest }) => {
  return (
    <InputDateContainer id="input-date">
      <InputDateLabel htmlFor={id}>{label}</InputDateLabel>
      <InputDateGroup className={error && 'error'} readOnly={readOnly}>
        <InputDateField ref={register} onBlur={() => onBlur()} id={id} defaultValue={defaultValue} {...rest} />
        <FaRegCalendar size={20} color={colors.textSecondary} id="calendar-icon" />
      </InputDateGroup>
      {error && <InputDateMessageError error={error}>{error.message}</InputDateMessageError>}
    </InputDateContainer>
  )
}

export default InputDate
